import React, { Component } from "react";
import Header from "../components/Header_footer/Header";
import Footer from "../components/Header_footer/Footer";
import axios from 'axios';
import { withRouter } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { clearSession } from "../redux/actions/session_actions";

function Layout(props) {

  let dispatch = useDispatch()
  // Axios interceptors are functions that execute for every HTTP request or response within an Axios instance.
  // They act as middleware, allowing us to modify requests before they're sent and responses before they're handled by our application. 
  // This provides a centralized way to handle tasks like authentication, error handling, and logging, making your code cleaner and more efficient. 

  axios.interceptors.response.use(
    (response) => {
      // Handle successful responses globally
      console.log('Global_API_Response_SUCCESS', response.data);

      if (response.data.status === "SESSION_OVER") {
        props.history.push("/session-over")
      }
      else {
        return response;
      }
    },
    (error) => {
      // Handle errors globally
      console.error('Global_API_Response_ERROR', error);
      return Promise.reject(error);
    }
  );

  return (
    <div>
      <Header />
      {props.children}
    </div>
  )
}


export default withRouter(Layout);
